
class QuickAdd {
  constructor(element) {
    this.element = element;
    this.init();
  }

  getElement() {
    return this.element;
  }

  getVariants(productCard) {
    let optionEl = productCard.querySelectorAll('.js-option');
    let buttonEl = productCard.querySelector('.js-add');
    let imageEl = productCard.querySelector('.js-image');

    for(let option of optionEl) {
      option.addEventListener('click', () => {
        option.closest('.js-options').querySelector('.active').classList.remove('active');
        option.classList.add('active');
        buttonEl.dataset.variant = option.dataset.variantId;
        option.dataset.image !== '' ? imageEl.src = option.dataset.image : null;
      })
    }
  }

  setAdd(productCard) {
    let productAddEl = productCard.querySelector('.js-add');

    productAddEl.addEventListener('click', () => {
      let addProduct = {
        id: productAddEl.dataset.variant,
        quantity: 1
      }
      window.vueApp.$store.dispatch('cart/addItem', addProduct)
      .then(() => window.vueApp.$store.dispatch('cart/openSidecart'))
      .catch(error => window.vueApp.$store.dispatch('toast/send', { text: error, type: 'error' }))
    })
  }

  setStates() {
    let productCardEl = this.getElement();

    for(let productCard of productCardEl) {
      this.getVariants(productCard);
      this.setAdd(productCard);
    }
  }

  setEventHandlers() {
    this.setStates();
  }

  init() {
    this.setEventHandlers();
  }
}


const QuickAddInit = {
  init() {
    const $el = document.querySelectorAll(".js-productCard");
    if ($el) {
        new QuickAdd($el);
    }
  },
};


export default QuickAddInit;